import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Form } from 'reactstrap'

import Helmet from '../components/Helmet/Helmet'
import CommonSection from '../components/UI/CommonSection'
import { formatPrice } from '../utils/formatPrice'
import '../styles/checkout.css'

const fields = [
  ['Full name', 'text', 'e.g. Maaz Ahmed'],
  ['Email address', 'email', 'you@example.com'],
  ['Phone number', 'tel', '+92 300 0000000'],
  ['Street address', 'text', 'House, street and area'],
  ['City', 'text', 'Your city'],
  ['Postal code', 'text', 'Postal code'],
  ['Country', 'text', 'Pakistan'],
]

const Popup = ({ handleClose, amount }) => (
  <div className='popup-box' role='dialog' aria-modal='true' aria-labelledby='payment-title'>
    <div className='box'>
      <button className='close-icon' onClick={handleClose} aria-label='Close payment window'><i className='ri-close-line'></i></button>
      <span className='payment__icon'><i className='ri-secure-payment-line'></i></span>
      <h2 id='payment-title'>Complete your payment</h2>
      <p>Your total is <strong>{formatPrice(amount)}</strong>. Continue to WhatsApp for verified bank-transfer details and order confirmation.</p>
      <a className='buy__btn w-100' target='_blank' rel='noopener noreferrer' href='https://wa.me/+923043321061'>Continue securely <i className='ri-arrow-right-up-line'></i></a>
    </div>
  </div>
)

const Checkout = () => {
  const totalQty = useSelector((state) => state.cart.totalQuantity)
  const totalAmount = useSelector((state) => state.cart.totalAmount)
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Helmet title='Checkout'>
      <CommonSection eyebrow='Secure checkout' title='Almost yours.' subtitle='Confirm your delivery details and review your order.' />
      <section>
        <Container>
          <Row className='g-5'>
            <Col lg='8'>
              <div className='checkout__heading'><span>01</span><div><h2>Delivery information</h2><p>Use the address where you would like your order delivered.</p></div></div>
              <Form className='billing__form'>
                {fields.map(([label, type, placeholder]) => <label className={label === 'Street address' ? 'full' : ''} key={label}><span>{label}</span><input type={type} placeholder={placeholder} required /></label>)}
              </Form>
            </Col>
            <Col lg='4'>
              <aside className='checkout__cart'>
                <span className='checkout__eyebrow'>Order summary</span>
                <div><span>Items</span><strong>{totalQty}</strong></div>
                <div><span>Subtotal</span><strong>{formatPrice(totalAmount)}</strong></div>
                <div><span>Delivery</span><strong>Free</strong></div>
                <div className='checkout__total'><span>Total</span><strong>{formatPrice(totalAmount)}</strong></div>
                <button className='buy__btn w-100' onClick={() => setIsOpen(true)} disabled={!totalQty}>Continue to payment</button>
                <p><i className='ri-lock-2-line'></i> Your payment details stay protected.</p>
              </aside>
            </Col>
          </Row>
        </Container>
      </section>
      {isOpen && <Popup amount={totalAmount} handleClose={() => setIsOpen(false)} />}
    </Helmet>
  )
}

export default Checkout
